import { useTranslation } from "react-i18next";
import styles from "./faq.module.css";
import Collapse from "../commons/Collapse/collapse";
import { Link } from "react-router-dom";

function Faq() {
  const { t } = useTranslation();
  return (
    <section className={styles.container} id="faq">
      <div className={styles.headers}>
        <h4>{t("faq.h4")}</h4>
        <h2>{t("faq.h2")}</h2>
      </div>
      <h3>{t("faq.section1")}</h3>
      <article className={styles.faqContent}>
        <Collapse title={t("faq.s1question1")} text={t("faq.s1answer1")} />
        <Collapse title={t("faq.s1question2")} text={t("faq.s1answer2")} />
        <Collapse title={t("faq.s1question3")} text={t("faq.s1answer3")} />
        <Collapse title={t("faq.s1question4")} text={t("faq.s1answer4")} />
        <Collapse title={t("faq.s1question5")} text={t("faq.s1answer5")} />
      </article>
      <h3>{t("faq.section2")}</h3>
      <article className={styles.faqContent}>
        <Collapse title={t("faq.s2question1")} text={t("faq.s2answer1")} />
        <Collapse title={t("faq.s2question2")} text={t("faq.s2answer21")}>
          <ul>
            <li>
              -<span className={styles.red}>{t("faq.s2answer22")}</span>
              {t("faq.s2answer23")}
            </li>
            <li>
              -<span className={styles.amber}>{t("faq.s2answer24")}</span>
              {t("faq.s2answer25")}
            </li>
            <li>
              -<span className={styles.green}>{t("faq.s2answer26")}</span>
              {t("faq.s2answer27")}
            </li>
          </ul>
        </Collapse>
        <Collapse title={t("faq.s2question3")} text={t("faq.s2answer3")} />
      </article>
      <h3>{t("faq.section3")}</h3>
      <article className={styles.faqContent}>
        <Collapse title={t("faq.s3question1")} text={t("faq.s3answer1")}>
          <span>
            <a
              className={styles.appLink}
              target="_blank"
              href={t("faq.s3answer1link")}
            >
              {t("faq.s3answer1link")}
            </a>
          </span>
        </Collapse>
        <Collapse title={t("faq.s3question2")} text={t("faq.s3answer2")} />
        <Collapse title={t("faq.s3question3")} text={t("faq.s3answer3")} />
        <Collapse title={t("faq.s3question4")} text={t("faq.s3answer4")} />
      </article>
      <h3>{t("faq.section4")}</h3>
      <article className={styles.faqContent}>
        <Collapse title={t("faq.s4question1")} text={t("faq.s4answer1")} />
        <Collapse title={t("faq.s4question2")} text={t("faq.s4answer2")} />
        <Collapse title={t("faq.s4question3")} text={t("faq.s4answer3")} />
      </article>
      <h3>{t("faq.section5")}</h3>
      <article className={styles.faqContent}>
        <Collapse title={t("faq.s5question1")} text={t("faq.s5answer1")} />
        <Collapse title={t("faq.s5question2")} text={t("faq.s5answer2")} />
        <Collapse title={t("faq.s5question3")} text={t("faq.s5answer3")} />
        <Collapse title={t("faq.s5question4")} text={t("faq.s5answer4")} />
      </article>
    </section>
  );
}

export default Faq;
